import React, { Fragment } from "react";
import { connect } from "react-redux";
import { print } from "graphql";
import { Mutation } from "@apollo/client/react/components";
import { Redirect } from "react-router-dom";
import { withRouter } from "react-router-dom";
import SimpleModal from "../../SimpleModal";
import SimpleForm from "../../SimpleForm";
import inputResolver from "../../SimpleForm/FieldResolver";
import UISchemaResolver from "../../../data/schema/form_ui/_resolver";
import PrefillUtil from "../../../global/utils/prefillHelper";
import util from "../../Utils/mappers";
import GQLUtil from "../../../global/utils/gqlHelper";
import FormExit from "../../SimpleForm/UI/FormExit";
import { withGoogleReCaptcha } from "react-google-recaptcha-v3";
import {
  GET_9035_FORM_DATA,
  UPDATE_9035_FORM,
  SUBMIT_9035_FORM,
  GET_9035_PROFILES,
} from "./queries";
import renderDeleteButton from "../renderDeleteButton";
import renderSaveButton from "../renderSaveButton";
import renderFormActions from "../renderFormActions";
import {
  cleanData,
  cleanDataForSubmission,
  reCheckFieldsOnLoad,
} from "./helpers";
// import { GET_PROFILES_DATA } from "../genericQueries";
import isTester from "../../SimpleForm/SubmissionUtilities/isTester";
import FullScreenSpinner from "../../../global/components/FullScreenSpinner";
import { fetchAllReferenceData } from "../../../global/app/actions/actions_reference";

class Form9035 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      closeModal: false,
      modalOpen: true,
      formSubmitting: false,
      profiles: [],
      counties: undefined,
      formData:
        (this.props.history.location.state &&
          this.props.history.location.state.initialValues) ||
        {},
      form_ui: undefined,
      reuse:
        (this.props.history.location.state &&
          this.props.history.location.state.reuse) ||
        false,
    };
  }

  componentDidMount = async () => {
    const application_type = "9035";
    const application_id = this.props.match.params.id;

    // if user is currently in app and reference data updates we want to fetch latest data when they open up the form
    // before we were checking if data existed in redux and if so skipping the fetch and not getting the latest data
    this.props.dispatch(fetchAllReferenceData());

    const profiles = await GQLUtil.genericGQLQuery(print(GET_9035_PROFILES));
    const profiles_parsed = PrefillUtil.getPrefillProfileOptions(
      profiles.data.getUserProfileInfo,
      application_type,
      "all"
    );
    util
      .getCounties()
      .then((data) => this.setState({ counties: data }))
      .catch((e) => {
        console.log(`unable to fetch counties`);
      });
    const form = await GQLUtil.genericGQLQuery(print(GET_9035_FORM_DATA), {
      id: application_id,
    });
    let formData = form.data.getForm9035ById.payload;
    if (form.data !== null) {
      let form_ui = form.data.getForm9035ById.form_ui;
      if (formData && form_ui) {
        reCheckFieldsOnLoad(form_ui, formData);
      }

      this.setState({
        profiles: profiles_parsed,
        formData,
        form_ui,
      });
    }

    if (
      this.props.history.location.state &&
      this.props.history.location.state.initialValues
    ) {
      this.setState({
        formData: {
          ...this.props.history.location.state.initialValues,
          ...(formData ?? {}),
        },
      });
    }
  };

  render9035 = () => {
    const application_type = "9035";
    const resolverName = "SubmitForm9035";
    const application_id = this.props.match.params.id;
    const useRecaptcha = this.props.user?.Recaptcha !== false;
    const { executeRecaptcha } = useRecaptcha
      ? this.props.googleReCaptchaProps
      : {};

    const handleToggle = () => {
      this.setState({ closeModal: !this.state.closeModal });
    };

    const renderFormExit = (values, form_ui, form_ui_name) => {
      return (
        <FormExit
          renderDeleteButton={() =>
            renderDeleteButton(
              application_id,
              application_type,
              this.props.history,
              undefined,
              this.props.user.GroupRole
            )
          }
          renderSaveButton={() =>
            renderSaveButton(
              UPDATE_9035_FORM,
              values,
              "Form9035FormData",
              application_id,
              cleanData,
              this.props.history,
              "Save as Initiated",
              undefined,
              undefined,
              form_ui,
              form_ui_name
            )
          }
          closeModal={this.state.closeModal}
          toggleModal={handleToggle}
          values={values}
        />
      );
    };

    const setFormSubmittingState = (booleanValue) => {
      this.setState({ formSubmitting: booleanValue });
    };

    const formSubmissionError = (e, application_id) => {
      setFormSubmittingState(false);
      if (e) {
        let error = JSON.stringify(e);
        let type;
        if (
          e &&
          e.graphQLErrors &&
          e.graphQLErrors[0] &&
          e.graphQLErrors[0].extensions
        ) {
          error = e.graphQLErrors[0].extensions;
        }
        if (
          e &&
          e.graphQLErrors &&
          e.graphQLErrors[0] &&
          e.graphQLErrors[0].message
        ) {
          type = e.graphQLErrors[0].message;
        }

        if (
          e &&
          e.networkError &&
          e.networkError.response &&
          e.networkError.response.status &&
          ([400, 500, 503].includes(e.networkError.response.status) ||
            [500].includes(e.networkError.statusCode))
        ) {
          error = "Service is temporarily down. Please try again later.";
        }
        this.props.history.push({
          pathname: "/dashboard/error",
          state: {
            formType: application_type,
            error: error,
            application_id,
            type,
          },
        });
      }
    };

    const formSubmissionSuccess = (res) => {
      const queueError = res?.[`${resolverName}`] === "queue_error";
      setFormSubmittingState(false);
      this.props.history.push({
        pathname: "/dashboard/success",
        state: { formType: application_type, queueError },
      });
    };

    return (
      <Fragment>
        {!this.state.modalOpen ? (
          <Redirect to="/dashboard/application" />
        ) : (
          <SimpleModal
            fullscreen={true}
            toggleModal={handleToggle}
            modalStatus={this.state.modalOpen}
          >
            <Mutation
              mutation={SUBMIT_9035_FORM}
              onError={(e) => formSubmissionError(e, application_id)}
              onCompleted={(e) => formSubmissionSuccess(e)}
            >
              {(SubmitForm9035) => {
                return (
                  <SimpleForm
                    handleSubmit={
                      useRecaptcha
                        ? async (values) => {
                            if (!executeRecaptcha) {
                              return;
                            }
                            const token = await executeRecaptcha(resolverName);
                            setFormSubmittingState(true);
                            SubmitForm9035({
                              variables: {
                                Form9035FormData: cleanDataForSubmission(
                                  cleanData(values)
                                ),
                                id: application_id,
                                token: token,
                              },
                            });
                          }
                        : (values) => {
                            setFormSubmittingState(true);
                            SubmitForm9035({
                              variables: {
                                Form9035FormData: cleanDataForSubmission(
                                  cleanData(values)
                                ),
                                id: application_id,
                              },
                            });
                          }
                    }
                    toggleClose={handleToggle}
                    toggleModal={handleToggle}
                    formExit={this.state.closeModal}
                    renderFormExit={renderFormExit}
                    renderFormActions={renderFormActions(
                      UPDATE_9035_FORM,
                      "Form9035FormData",
                      application_id,
                      cleanData,
                      this.props.history,
                      this.state.formSubmitting
                    )} // override default FormActions
                    formSaveMutation={UPDATE_9035_FORM}
                    formSaveMutationCallback={({
                      formValues,
                      formUIData,
                      saveForm,
                      profilePrefillMetadata,
                    }) => {
                      saveForm({
                        variables: {
                          formUI9035: formUIData,
                          Form9035FormData: cleanData(formValues),
                          id: application_id,
                          profilePrefillMetadata:
                            profilePrefillMetadata.profiles,
                        },
                      });
                    }}
                    multiPage={true}
                    uiSchema={UISchemaResolver(application_type)}
                    uiSchema_meta={UISchemaResolver(`${application_type}-meta`)}
                    uiSchema_nav={UISchemaResolver(`${application_type}-nav`)}
                    uiSchema_lookup={UISchemaResolver(
                      `${application_type}-lookup`
                    )}
                    inputResolver={inputResolver}
                    initialValues={this.state.formData}
                    profiles={this.state.profiles}
                    counties={this.state.counties}
                    form_ui={this.state.form_ui}
                    form_ui_name={"formUI9035"}
                    formSubmitting={this.state.formSubmitting}
                    disableValidation={
                      (this.props.user &&
                        this.props.user.Roles &&
                        isTester(this.props.user && this.props.user.Roles)) ||
                      false
                    }
                    returningToForm={this.state.reuse}
                  />
                );
              }}
            </Mutation>
          </SimpleModal>
        )}
      </Fragment>
    );
  };

  render() {
    if (this.state.formData !== undefined && this.state.form_ui !== undefined) {
      return <div>{this.render9035()}</div>;
    }
    return <FullScreenSpinner />;
  }
}

const mapStateToProps = (state) => ({
  user: state.appReducer.userDataReducer.data,
  referenceData: state.referenceReducer,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
});

const ConnectedForm = connect(mapStateToProps, mapDispatchToProps)(Form9035);
const RoutedForm = withRouter(ConnectedForm);

const FormWrapper = (props) => {
  const useRecaptcha = props.user?.Recaptcha !== false;
  const ComponentToRender = useRecaptcha
    ? withGoogleReCaptcha(RoutedForm)
    : RoutedForm;

  return <ComponentToRender {...props} />;
};

export default FormWrapper;
